/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : LoginEvaluationExecutor.ts
*******************************************/

import { isShowSimpleMessage, ShowSimpleMessage } from "../../EvaluatedAction.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { Logger } from "@ciaopeople/cp-shatsu/Logging";
import { CTAExecutionResult, EvaluatedActionExecutor, isDismissedCTA, NamedCtaEvaluator } from "../EvaluatedActionExecutor.js";

export class MessageEvaluationExecutor implements EvaluatedActionExecutor {
    public isExpectedType = isShowSimpleMessage;

    constructor(
        private readonly sdk: ClientSdkPublicInterface,
        private logger: Logger
    ) {

    }

    execute(evaluator: NamedCtaEvaluator, res: ShowSimpleMessage, data?: any): Promise<CTAExecutionResult> {
        return this.sdk.getGui().then(
            gui => {
                return gui.showSimpleNotificationMessage(res.data.text, res.data.closeAfter).then(
                    x => isDismissedCTA(x) ? CTAExecutionResult.DISMISSED : CTAExecutionResult.COMPLETED
                ); 
            }
        );
    }
}
